import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';
import { marketingCampaignsQueryKey } from 'src/app/queries/marketing/get-campaigns';

import type { GridValidRowModel } from '@mui/x-data-grid-pro';
import type { UseQueryOptions } from '@tanstack/react-query';

const GET_CAMPAIGN_PUSH_RECIPIENTS = 'api/marketing-campaign/get-push-campaign-audience';

export type PushRecipient = GridValidRowModel & {
  CustomerId: number;
  FirstName: string;
  LastName: string;
  OpenedUtc: string | null;
  SentUtc: string | null;
};

type CampaignPushRecipientsResponse = {
  Data: PushRecipient[];
  Page: number;
  TotalPages: number;
  TotalRows: number;
};

type CampaignPushRecipientsQueryParams = {
  currentPage: number;
  endDate?: string;
  marketingCampaignId: string;
  pageSize: number;
  searchTerm?: string;
  sortAscending: boolean;
  sortColumn: string;
  startDate?: string;
};

export function useCampaignPushRecipientsQuery(
  params: CampaignPushRecipientsQueryParams,
  options: UseQueryOptions<CampaignPushRecipientsResponse> = { enabled: true }
) {
  options.enabled = options.enabled && Boolean(params.marketingCampaignId && params.marketingCampaignId !== '0');

  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'push-recipients', params],
    queryFn: async () =>
      fetchData<CampaignPushRecipientsResponse>(
        GET_CAMPAIGN_PUSH_RECIPIENTS,
        {
          MarketingCampaignId: parseInt(params.marketingCampaignId, 10),
          CurrentPage: params.currentPage,
          PageSize: params.pageSize,
          SearchTerm: params.searchTerm ?? '',
          SortAscending: params.sortAscending,
          SortColumn: params.sortColumn,
          StartDate: params.startDate,
          EndDate: params.endDate,
        },
        {
          error: { args: { message: 'Failed to fetch campaign push recipients.' } },
        }
      ),
    ...options,
  });
}
